module.exports = __webpack_public_path__ + "public/media/warning_triangle.cabf588a.svg";